import { useEffect, useRef, useState } from "react";
import PetInformation from "../PetInformation";
import VaccinationInfo from "../VaccinationInfo";

const PetVaccinationCertificate = () => {
  const [value, setValue] = useState(
    "This is to certify that, the above mentioned pet animal is duly immunized with all recommended core vaccinations including Rabies (Please refer to the vaccination records below)",
  );

  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    adjustHeight();
  }, [value]);

  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Adjust to content
    }
  };

  return (
    <div>
      <div>
        <PetInformation />
      </div>
      <div className="gap-2 flex mt-2 flex-col">
        <textarea
          ref={textareaRef}
          className="w-full border p-4 text-sm resize-none print:hidden"
          value={value} // Controlled component to retain content
          onChange={(e) => setValue(e.target.value)}
          onInput={adjustHeight}
          style={{
            overflowY: "auto",
            scrollbarWidth: "thin",
          }}
        />
        <div className="hidden print:block w-full print:border-none p-2 text-sm whitespace-pre-wrap">{value}</div>
      </div>
      <div>
        <VaccinationInfo />
      </div>
      <p className="py-3 ">Veterinary Provider Information:</p>
      <div className="gap-2 flex  items-center w-full pt-3">
        <p className="text-xs w-[200px]">Doctor's Name</p>
        <input type="text" className="text-sm w-[400px]" />
      </div>
      <div className="gap-2 flex  items-center w-full mt-5">
        <p className="text-xs w-[200px]">Doctor's License Number:</p>
        <input type="text" className="text-sm w-[400px]" />
      </div>
      <div className="flex items-center justify-between pt-4">
        <p>Date</p>
        <p>Veterinarian's Signature</p>
      </div>
      <p className="pt-3 font-bold italic">This report is not valid for Vetero-Legal Purposes</p>
    </div>
  );
};

export default PetVaccinationCertificate;
